

function TinymceHelper($parse, $translate, $timeout, $filter) {
	return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
		},
        controller: function($scope, LocaleService, Classes, $cookies) {
            var self = this
            
            this.tinymceOptions = {
                plugins: 'autolink autoresize code contextmenu fullscreen image link lists media paste table textcolor colorpicker visualblocks visualchars',
                toolbar: 'undo redo | bold italic forecolor backcolor | alignleft aligncenter alignright numlist bullist table | image link media | code fullscreen',
                autoresize_max_height: 500,
                autoresize_bottom_margin: 25,
                //language: LocaleService.getLocale().replace(/([a-z]*)_[A-Z]*/, '$1'),
                language_url: 'bower_components/tinymce/langs/' + LocaleService.getLocale().replace(/([a-z]*)_[A-Z]*/, '$1') + '.js',  // suport useref, minify
                inline: true,
                browser_spellcheck: true, /* contextmenu: false */
                skin_url: 'bower_components/tinymce/skins/lightgray',  // suport useref, minify
                table_class_list: [
                    {title: 'None', value: ''},
                    {title: 'Default', value: 'table'},
                    {title: 'Condensed', value: 'table table-condensed'},
                    {title: 'Bordered', value: 'table table-bordered'},
                    {title: 'Striped', value: 'table table-striped'},
                    {title: 'Bordered Striped', value: 'table table-striped table-bordered'},
                ],
                table_responsive_width: true,   // force % size

                paste_data_images: true,  // allow image dnd, paste in Word
                paste_enable_default_filters: true,  // to enable valid_elements
                /*paste_word_valid_elements: "@[style],-strong/b,-em/i,-span,-p,-ol,-ul,-li,-h1,-h2,-h3,-h4,-h5,-h6," +
                    "-table[border|cellspacing|cellpadding|frame|rules|align|summary|style|class],"+
                    "-tr[rowspan|align|valign|style],tbody,thead,tfoot,#td[colspan|rowspan|align|valign|scope|style],"+
                    "#th[colspan|rowspan|align|valign|scope|style],-a[href|title],img[src|title|alt|class],sub,sup,strike,caption,br",
                */
                paste_word_valid_elements: "-strong/b,-em/i,-p,-ol,-ul,-li,-h1,-h2,-h3,-h4,-h5,-h6," +
                    "-table[align|summary|class:table],"+
                    "-tr[rowspan|align|valign],tbody,thead,tfoot,#td[colspan|rowspan|align|valign|scope],"+
                    "#th[colspan|rowspan|align|valign|scope],-a[!href|title],img[src|title|alt|class|width|height],sub,sup,strike,caption,br",
                
                paste_preprocess: function(plugin, args) {
                    args.content = args.content.replace(/<!--[\s\S]*?-->/g, '');
                    args.content = args.content.replace(/<!\[[^>]*\]>/g, '');
                },
                file_picker_types: 'image',  // file image media

                relative_urls: false,
                images_reuse_filename: true,
                // basic upload handler - automatick for local media
                images_upload_handler: self.field.client.image_class ? function (blobInfo, success, failure) {
                    var xhr, formData;
                
                    xhr = new XMLHttpRequest();
                    xhr.withCredentials = false;
                    xhr.open('POST', Classes[self.field.client.image_class].ApiRootPath + '/upload');
                    xhr.setRequestHeader('X-XSRF-TOKEN', $cookies.get('XSRF-TOKEN'))
                
                    xhr.onload = function() {
                      var json;

                      json = JSON.parse(xhr.responseText);
                
                      if (!json || typeof json.location != 'string') {
                        if (xhr.status != 200) {
                            failure('HTTP Error: ' + xhr.status);
                        } else {
                            failure('Invalid JSON: ' + xhr.responseText);
                        }
                        return;
                      }
                
                      if (xhr.status != 200) {
                        failure('Upload error: ' + (json.message || 'Unknown error'));
                        return;
                      }
                
                      success(json.location);
                    };
                
                    formData = new FormData();
                    formData.append('file', blobInfo.blob(), blobInfo.blob().name || blobInfo.filename());
                
                    xhr.send(formData);
                } : null,

                // local file picker
                file_picker_callback: function(cb, value, meta) {
                    var input = document.createElement('input');
                    input.setAttribute('type', 'file');
                    input.setAttribute('accept', 'image/*');
                    
                    // Note: In modern browsers input[type="file"] is functional without 
                    // even adding it to the DOM, but that might not be the case in some older
                    // or quirky browsers like IE, so you might want to add it to the DOM
                    // just in case, and visually hide it. And do not forget do remove it
                    // once you do not need it anymore.
                
                    input.onchange = function() {
                      var file = this.files[0];
                      
                      var reader = new FileReader();
                      reader.onload = function () {
                        // Note: Now we need to register the blob in TinyMCEs image blob
                        // registry. In the next release this part hopefully won't be
                        // necessary, as we are looking to handle it internally.
                        // var id = 'blobid' + (new Date()).getTime();
                        var id = file.name || ('blobid' + (new Date()).getTime());
                        var blobCache =  tinymce.activeEditor.editorUpload.blobCache;
                        var base64 = reader.result.split(',')[1];
                        var blobInfo = blobCache.create(id, file, base64);
                        blobCache.add(blobInfo);
                
                        // call the callback and populate the Title field with the file name
                        cb(blobInfo.blobUri(), { title: file.name });
                      };
                      reader.readAsDataURL(file);
                    };
                    
                    input.click();
                  }
            }
            
        },
        controllerAs: '$tinymcehelper'
    }
}

angular.module('forms.fields.html.medium', ['angular-medium-editor'])
;
angular.module('forms.fields.html.tinymce', ['ui.tinymce'])
.directive('tinymceHelper', TinymceHelper)
;